export default __webpack_public_path__ + "static/media/v2.f6d73b19.jpg";